import {createSelector} from '@reduxjs/toolkit'
import {populateBusinessContactDetailsForReview} from './businessContactDetailSelector'
import {
    populateLicenceHistoryListQuestionForReview,
    populateLicenceHistoryListDataForReview,
    populateLicenceSuspensionQuestionForReview,
    populateLicenceSuspensionDataForReview
} from './licenceDetailsSelector'
import {populateAdditionalBranchesData} from './additionalBranchSelector'
import {populateSupportingDocumentsData} from './supportingDocumentsSelector'
import {
    populateBusinessEntityDetailsForReview,
    populateBusinessPeopleListForReview
} from './rjscSearchSelector'
import {populateCriminalHistoryListDataForReview} from './criminalDetailsSelector'
import { populateWorkHistoryListDataForReview } from './workHistoryDetailsSelector'
import { populateAddressForServiceDetails } from './addressForServiceSelector'
import { populateAddressForFinanceDetails } from './addressForFinancialRecordsSelector'
import {
    APPLICATION_STATUS_PENDING_PAYMENT,
    DOCUMENT_TYPE_FORMS_AGREEMENTS,
    DOCUMENT_TYPE_NOTICES_LETTERS,
    DOCUMENT_TYPE_SURETY_BONDS,
    LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
    LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL 
} from '../../app/constants'

export const applicationReviewSelector = createSelector(
    [state => state.components,
    state => state.primaryAgencyApplication, 
    state => state.additionalApplications],
    (components, businessLicenceApplicationData, additionalApplications) => {

        const appData = businessLicenceApplicationData.application?.businessLicenceData

        const {
            companyRjscDetails,
            mainBusinessContact,
            complianceOfficer,
            responsibleAgent,
            serviceCivicAddress,
            financialRecordsLocation,
            licenceHistoryList,
            licenceSuspendedData,
            criminalHistoryData,
            workHistoryData,
            companyTrademark
        } = appData

        const formsAgreements = []
        const noticesLetters = []
        const suretyBondDocs  = []

        if (businessLicenceApplicationData.application?.documents
            && Array(businessLicenceApplicationData.application.documents)) { 
                businessLicenceApplicationData.application.documents.forEach(document => {
                    if(document.documentType === DOCUMENT_TYPE_NOTICES_LETTERS) { 
                        noticesLetters.push(document)
                    } else if(document.documentType === DOCUMENT_TYPE_FORMS_AGREEMENTS) {
                        formsAgreements.push(document)
                    } else if(document.documentType === DOCUMENT_TYPE_SURETY_BONDS) {
                        suretyBondDocs.push(document)
                    }
                })
        }
        const additionalBranches = []

        if(additionalApplications.additionalBranchApplications
            && Array.isArray(additionalApplications.additionalBranchApplications)) { 
                additionalApplications.additionalBranchApplications.forEach(branchApplication => 
            {
                // branch status will be marked do not renew if user did not select it for renewal
                if(!branchApplication.markedDoNotRenew && !branchApplication.markedDeleted) {
                    if(branchApplication.businessLicenceData
                        && branchApplication.businessLicenceData.additionalBranches 
                        && Array.isArray(branchApplication.businessLicenceData.additionalBranches)
                        && branchApplication.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT //For renewal, show only applicable 
                    ) 
                    { 
                        branchApplication.businessLicenceData.additionalBranches.forEach(branch => {
                            additionalBranches.push({...branch, ...{id : branchApplication.id}})
                        })
                    }
                }
            })
        }

        return Object.assign({},
            components.applicationReview,
            appData,
            {
                applicationSavingRequestStatus : businessLicenceApplicationData.serverRequestStatus,
                supportingDocumentsRawData : businessLicenceApplicationData.application?.documents ?? [],
                reviewDetails : {
                    businessEntityDetails : populateBusinessEntityDetailsForReview(companyRjscDetails),
                    companyTrademarkDetails : {"Company trademark name" : companyTrademark ?? ""},
                    businessPeopleDetails : populateBusinessPeopleListForReview(companyRjscDetails),
                    businessContact : populateBusinessContactDetailsForReview(mainBusinessContact),
                    complianceOfficer : populateBusinessContactDetailsForReview(complianceOfficer),
                    responsibleAgent: populateBusinessContactDetailsForReview(responsibleAgent),
                    addressForService : populateAddressForServiceDetails(serviceCivicAddress),
                    addressForFinance : populateAddressForFinanceDetails(financialRecordsLocation),
                    LicenceHistoryListQuestion : populateLicenceHistoryListQuestionForReview(licenceHistoryList),
                    LicenceHistoryListData : populateLicenceHistoryListDataForReview(licenceHistoryList),
                    criminalHistoryListData : populateCriminalHistoryListDataForReview(criminalHistoryData),
                    workHistoryListData : populateWorkHistoryListDataForReview(workHistoryData),
                    licenceSuspendedQuestion : populateLicenceSuspensionQuestionForReview(licenceSuspendedData),
                    licenceSuspendedData : populateLicenceSuspensionDataForReview(licenceSuspendedData),
                    additionalBranches : populateAdditionalBranchesData(additionalBranches),
                    supportingDocuments : populateSupportingDocumentsData(formsAgreements, noticesLetters),
                    agents : additionalApplications.agentApplications
                                    .filter(agentApp => (agentApp.applicationStatus === APPLICATION_STATUS_PENDING_PAYMENT 
                                        && (agentApp.licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL || 
                                            agentApp.licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_INDIVIDUAL_RENEWAL)))
                                    .map(agentApp => {
                                            return {
                                                id : agentApp.id,
                                                contactName: agentApp.contactName
                                            }
                                        })
                }
            }
        )
    }
)

export const applicationReviewSelect = state => ({
    applicationReview: applicationReviewSelector(state)
})
